import React from 'react';
import { Handle, Position } from 'reactflow';
import { motion } from 'framer-motion';

// Stryde brand colors for each audience
const AUDIENCE_COLORS = {
  patients: {
    bg: '#0070FF',
    text: '#FFFFFF',
  },
  sponsors: {
    bg: '#FF7F00',
    text: '#FFFFFF',
  },
  physicians: {
    bg: '#0070FF',
    text: '#FFFFFF',
    gradient: 'linear-gradient(135deg, #0070FF 0%, #FF7F00 100%)',
  },
};

const AudienceNode = ({ data, selected }) => {
  const { label, description, active } = data;
  const colors = AUDIENCE_COLORS[label.toLowerCase()] || { bg: '#0070FF', text: '#FFFFFF' };

  return (
    <motion.div
      className={`audience-node-solid ${active ? 'active' : ''}`}
      data-testid={`audience-node-${label.toLowerCase()}`}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 200, damping: 15 }}
      style={{
        background: colors.gradient || colors.bg,
        color: colors.text,
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: '#000', width: 8, height: 8 }}
      />
      
      <div className="audience-node-content">
        <span className="audience-node-title">{label}</span>
        {description && (
          <span className="audience-node-desc">
            {description}
          </span>
        )}
      </div>

      <Handle
        type="source"
        position={Position.Right}
        style={{ background: '#000', width: 8, height: 8 }}
      />
    </motion.div>
  );
};

export default AudienceNode;
